// ##### 25-04-30 Komarov
import uniqueId from 'lodash.uniqueid';
// ##### Komarov 2025-07-18
import React, { useEffect, useState } from 'react';
import { sliderFrequency } from '../../Context/config';
// ##### 25-05-21 Komarov
import ArrowSlider from './ArrowSlider';
import Slide from './Slide';
import SliderContent from './SliderContent';

// ##### Komarov 2025-07-18
const SliderDiv = ({ className, slides }) => {
  const getWidth = () => window.innerWidth;

  const prevSlide = () => {
    if (activeIndex === 0) {
      return setState({
        ...state,
        translate: (slides.length - 1) * getWidth(),
        activeIndex: slides.length - 1,
      });
    }

    setState({
      ...state,
      activeIndex: activeIndex - 1,
      translate: (activeIndex - 1) * getWidth(),
    });
  };

  const [state, setState] = useState({
    activeIndex: 0,
    translate: 0,
    transition: 0.45,
  });

  const { translate, transition, activeIndex } = state;

  const nextSlide = () => {
    if (activeIndex === slides.length - 1) {
      return setState({
        ...state,
        translate: 0,
        activeIndex: 0,
      });
    }
    // ##### 24-03-21 Komarov
    return setState({
      ...state,
      activeIndex: activeIndex + 1,
      translate: (activeIndex + 1) * getWidth(),
    });
  };

  // ##### Komarov 2025-07-12
  useEffect(() => {
    let timer = null;
    timer = setTimeout(nextSlide, sliderFrequency);
    return () => {
      clearInterval(timer);
    };
  }, null);

  // ##### 23-10-06 Komarov: TODO: Может, здесь лишний один слой div ?..
  return (
    <div data-component="SliderDiv">
      <div className={className}>
        <SliderContent
          translate={translate}
          transition={transition}
          index={activeIndex}
          width={getWidth() * slides.length}
        // width='100%'
        >
          {/* ##### 24-03-21 Komarov */}
          {slides.map((slide /* , index */) => (
            <Slide
              key={uniqueId()}
              content={(process.env.REACT_APP_SMART_PROTOCOL || 'https://') + slide}
            />
          ))}
        </SliderContent>

        <div className="Arrows">
          <ArrowSlider direction="left" handleClick={prevSlide} />

          <ArrowSlider direction="right" handleClick={nextSlide} />
        </div>
      </div>
    </div>
  );
};

export default SliderDiv;
